import React, { useState } from 'react'
import Card from './Card'
import Menu from './FoodApi'
import { Link } from "react-router-dom";

const Resturant = () => {
    const [menuData, setmenuData] = useState(Menu)

    const filterItem = (category)=>{
    const updateList = Menu.filter((currElm)=>{
        return currElm.category === category;
    });
    setmenuData(updateList)
    }

  return (
    <>
     <>
     <nav className="navbar navbar-dark bg-dark" style={{marginTop: '100px'}}>
  <div className="container-fluid">
    <Link className="navbar-brand" to="/">IResturant</Link>
    <div>
      <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{border: '1px solid grey', borderRadius: '18px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0'}}>
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#" onClick={()=>{setmenuData(Menu)}}><strong>All</strong></a>
        </li>
        <li className="nav-item">
          <a className="nav-link active" href="#" onClick={()=>{filterItem("Breakfast")}}><strong>Breakfast</strong></a>
        </li>
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#" onClick={()=>{filterItem("Lunch")}}><strong>Lunch</strong></a>
        </li>
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#" onClick={()=>{filterItem("Dinner")}}><strong>Dinner</strong></a>
        </li>
      </ul>
    </div>
  </div>
</nav>


    </>
     <Card menuData={menuData}/>
    </>
  )
}

export default Resturant
